import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbb10ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "THE FIELDS MARKED WITH (*) ARE REQUIRED.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Artwork Info", -1))
const _hoisted_4 = {
  key: 0,
  class: "input-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ARTIST*", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "website title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "TITLE*", -1))
const _hoisted_10 = { class: "input-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "YEAR", -1))
const _hoisted_12 = { class: "input-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "MEDIUM*", -1))
const _hoisted_14 = { class: "input-container description" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ART DESCRIPTIONS*", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Please select an option", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "description-option-text" }
const _hoisted_19 = { class: "input-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "EDITION OF", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Please enter a number if related to prints, sculpture, and photography. For example: 1/10. ", -1))
const _hoisted_22 = { class: "input-container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "THEMES*", -1))
const _hoisted_24 = { class: "input-container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "COLOURS*", -1))
const _hoisted_26 = { class: "input-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "HEIGHT(CM)", -1))
const _hoisted_28 = { class: "input-container" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "WIDTH(CM)", -1))
const _hoisted_30 = { class: "input-container" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "DEPTH", -1))
const _hoisted_32 = { class: "input-container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "WEIGHT", -1))
const _hoisted_34 = { class: "input-container" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "SIGNED", -1))
const _hoisted_36 = { class: "input-container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "FRAMED", -1))
const _hoisted_38 = { class: "about" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CERTIFICATE", -1))
const _hoisted_40 = { class: "about" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PROVENANCE", -1))
const _hoisted_42 = { class: "about" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CONDITION NOTE", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Main Image", -1))
const _hoisted_45 = { class: "image-container" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Additional Info", -1))
const _hoisted_49 = { class: "input-container" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ORIENTATION OF ARTWORK*", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "This is needed for filtering items", -1))
const _hoisted_52 = { class: "input-container" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "SIZE OF ARTWORK*", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "This is needed for filtering items", -1))
const _hoisted_55 = { class: "country-container" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Location of Artwork", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "region" }, "REGION*", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select Region", -1))
const _hoisted_59 = ["value"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "COUNTRY*", -1))
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select Country", -1))
const _hoisted_63 = ["value"]
const _hoisted_64 = { class: "input-container" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "LOCATION", -1))
const _hoisted_66 = { class: "about" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "SHIPPING", -1))
const _hoisted_68 = { class: "about" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Extra Details", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Pricing", -1))
const _hoisted_71 = { class: "input-container" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PRICE($)", -1))
const _hoisted_73 = {
  key: 0,
  class: "pricing-note"
}
const _hoisted_74 = {
  key: 0,
  class: "input-container"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "MINIMUM OFFER PRICE", -1))
const _hoisted_76 = { class: "buttons" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 0,
  class: "publishing-state"
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "publishing-state"
}
const _hoisted_83 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", null, [
          _createElementVNode("section", null, [
            _hoisted_3,
            (_ctx.role === 'gallery' || _ctx.isPrivateSeller)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.artistId) = $event)),
                    required: ""
                  }, [
                    _createElementVNode("option", {
                      value: _ctx.artist,
                      selected: ""
                    }, _toDisplayString(_ctx.artist) + " " + _toDisplayString(_ctx.artistId), 9, _hoisted_6),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artists, (artist) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: artist.id,
                        value: artist.id
                      }, _toDisplayString(artist.full_name), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.artistId]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Title",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event))
              }, null, 512), [
                [_vModelText, _ctx.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.year,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event)),
                "hide-details": "",
                "single-line": "",
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_v_select, {
                items: _ctx.artCategories,
                required: "",
                modelValue: _ctx.artCategoriesSelected,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.artCategoriesSelected) = $event)),
                multiple: ""
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.artDescriptionSelected) = $event)),
                class: "description-select"
              }, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artDescriptions, (description) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: description,
                    value: description,
                    class: "description-option"
                  }, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(description), 1)
                  ], 8, _hoisted_17))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.artDescriptionSelected]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _hoisted_21,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.edition,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.edition) = $event)),
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_v_select, {
                items: _ctx.themes,
                modelValue: _ctx.themesSelected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.themesSelected) = $event)),
                multiple: "",
                required: ""
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_v_select, {
                items: _ctx.colors,
                modelValue: _ctx.colorsSelected,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.colorsSelected) = $event)),
                multiple: "",
                required: ""
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.height,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.height) = $event)),
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.width,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.width) = $event)),
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.depth,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.depth) = $event)),
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.weight,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.weight) = $event)),
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_v_select, {
                items: _ctx.signed,
                modelValue: _ctx.signedSelected,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.signedSelected) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_v_select, {
                items: _ctx.framed,
                modelValue: _ctx.framedSelected,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.framedSelected) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.certificate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.certificate]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.provenance) = $event)),
                placeholder: "Provide a brief history of the artworks previous ownership."
              }, null, 512), [
                [_vModelText, _ctx.provenance]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.condition) = $event))
              }, null, 512), [
                [_vModelText, _ctx.condition]
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              (_ctx.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imageUrl
                  }, null, 8, _hoisted_46))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/imgs/avatar.png')
                  }, null, 8, _hoisted_47)),
              _createElementVNode("label", null, [
                _createTextVNode(" UPLOAD IMAGE "),
                _createElementVNode("input", {
                  id: "image-upload",
                  type: "file",
                  onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                  style: {"display":"none"},
                  multiple: ""
                }, null, 32)
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _hoisted_51,
              _createVNode(_component_v_select, {
                items: _ctx.orientations,
                modelValue: _ctx.orientationSelected,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orientationSelected) = $event)),
                required: ""
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _hoisted_54,
              _createVNode(_component_v_select, {
                items: _ctx.sizes,
                modelValue: _ctx.sizeSelected,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.sizeSelected) = $event)),
                required: ""
              }, null, 8, ["items", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("div", null, [
                _hoisted_57,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.region) = $event)),
                  required: ""
                }, [
                  _hoisted_58,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: region.id,
                      value: region.name
                    }, _toDisplayString(region.name), 9, _hoisted_59))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.region]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_60,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.country) = $event)),
                  disabled: _ctx.filteredCountries.length === 0,
                  required: ""
                }, [
                  _hoisted_62,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: country.id,
                      value: country.name
                    }, _toDisplayString(country.name), 9, _hoisted_63))
                  }), 128))
                ], 8, _hoisted_61), [
                  [_vModelSelect, _ctx.country]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.location,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.location) = $event)),
                "hide-details": "",
                "single-line": "",
                placeholder: "Enter city name, followed by the name of the country. For example: Beirut, Lebanon."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.shipping) = $event))
              }, null, 512), [
                [_vModelText, _ctx.shipping]
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.details) = $event)),
                placeholder: "Tell the story of the artwork."
              }, null, 512), [
                [_vModelText, _ctx.details]
              ])
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.price,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.price) = $event)),
                "hide-details": "",
                "single-line": "",
                placeholder: "numbers only",
                type: "number"
              }, null, 8, ["modelValue"]),
              (_ctx.isPrivateSeller)
                ? (_openBlock(), _createElementBlock("p", _hoisted_73, " This price includes our 15% commission fee as agreed in the terms and conditions. "))
                : _createCommentVNode("", true)
            ]),
            (_ctx.role === 'gallery' || _ctx.isPrivateSeller)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _hoisted_75,
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.minimumOfferPrice,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.minimumOfferPrice) = $event)),
                    "hide-details": "",
                    "single-line": "",
                    type: "number"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "hidden",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.quantity) = $event))
            }, null, 512), [
              [_vModelText, _ctx.quantity]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$router.back()))
          }, "BACK"),
          (!_ctx.duplicate && _ctx.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                disabled: _ctx.artwork.active !== true,
                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.deleteArtwork && _ctx.deleteArtwork(...args)))
              }, " REMOVE FROM LISTING ", 8, _hoisted_77))
            : _createCommentVNode("", true),
          (_ctx.role !== 'artist' && _ctx.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.updateOrAddArtwork && _ctx.updateOrAddArtwork(...args))),
                disabled: _ctx.isPublishing
              }, [
                (_ctx.isPublishing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                      _createVNode(_component_SpinnerLoader, {
                        color: "white",
                        size: 16
                      }),
                      _createTextVNode(" UPDATING... ")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_80, "UPDATE"))
              ], 8, _hoisted_78))
            : _createCommentVNode("", true),
          (!_ctx.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.updateOrAddArtwork && _ctx.updateOrAddArtwork(...args))),
                disabled: _ctx.isPublishing
              }, [
                (_ctx.isPublishing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                      _createVNode(_component_SpinnerLoader, {
                        color: "white",
                        size: 16
                      }),
                      _createTextVNode(" PUBLISHING... ")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_83, "PUBLISH"))
              ], 8, _hoisted_81))
            : _createCommentVNode("", true),
          (_ctx.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.duplicateArtwork(_ctx.id)))
              }, " DUPLICATE "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}